/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, mediaQuery } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// DATE PICKER FILTER
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme =>({
    daterangepickerdropdown:{
        height: pxToEm(56),
        minWidth: pxToEm(230),
        maxWidth: pxToEm(275), //pxToEm(255),
        position: 'relative',
        '& .placeholder': {
            width:'100%',
            height:'100%',
            fontSize: pxToEm(15),
            padding: pxToEm(18),
            background: theme.color.light.light.swatch,
            borderRadius: pxToEm(4),
            display: 'flex',
            justifyContent: 'space-between',
            alignItems:'center',
            boxShadow: theme.boxShadow.small,
            cursor: 'pointer',
            border: `${pxToEm(2)} solid transparent`,
            transition: 'border .2s linear 0s',
            '&:hover':{
                borderColor: theme.color.secondary.light.swatch
            },
            '&.active-true': {
                borderColor: theme.color.primary.medium.swatch
            }
        },
        '& .name-dropdown': {
            display: 'flex',
            alignItems: 'center',
            flexDirection: 'column',
            background: theme.color.light.light.swatch,
            height: 'auto',
            // maxHeight: pxToEm(385),
            width: pxToEm(550),
            padding: pxToEm(8),
            transition: 'all .15s',
            position: props => props.alignedRight ? 'relative' : 'absolute',
            zIndex: 1,
            right: 0,
            boxShadow: theme.boxShadow.small,
            '&.active-false': {
                height: '0px',
                overflow: 'hidden',
                transition: 'all .15s',
                padding: 0
            },
            '& .ctas.name-date-ranges': {
                width: '100%',
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'space-around',
                alignItems: 'center',
                padding: replacePXinStringWithEM('24px 24px 0'),
                '& .button':{
                    height: pxToEm(40),
                    width: pxToEm(135),
                    fontSize: pxToEm(12),
                    color: theme.color.supporting.light.contrast,
                    background: theme.color.neutral.xlight.swatch,
                    border: 'none',
                    padding: 0
                }
            },
            '& .ctas.name-date-ranges.hide-true': {
              display: 'none'
            },
            '& .datepicker': {
                paddingTop: pxToEm(24),
                '& .DayPicker-Months': {
                    flexWrap: 'wrap'
                }
            },
            '& .ctas.name-clear-apply': {
                width: '100%',
                justifyContent: 'space-between',
                padding: ` 0 ${pxToEm(20)} ${pxToEm(20)} ${pxToEm(20)}`
            },
            '& .ctas.name-clear-apply.hide-true': {
                display: 'none'
            },
        }
    },

    // ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
    [mediaQuery.thinnest]: { 
        daterangepickerdropdown: {
            '& .name-dropdown': {
                width: '100%',
                '& .ctas.name-date-ranges': {
                    '& .button': {
                        width: '100%',
                        marginBottom: pxToEm(10),
                        '&:last-child': { marginBottom: '0' }
                    }
                }
            }
        }
    }
})